module Hereabout.Effects where

import Prelude

import Data.Either (Either)
import Data.Maybe (Maybe)
import Effect.Aff (Error)
import Halogen (RefLabel(..))
import Hereabout.Data.Route (HereaboutPage, Route)
import Hereabout.Navigator.Geolocation (Coordinates)
import Hereabout.Types (CommunityFeed(..), PostComment(..), User(..))
import Web.HTML (HTMLElement)

class (Monad m) <= Navigate m where
  navigate :: Route -> m Unit

class (Monad m) <= ResolveRoute m where
  resolveRoute :: Route -> m HereaboutPage

class (Monad m) <= LocationFeed m where
  getFeed :: Coordinates -> m CommunityFeed

class (Monad m) <= ShareURL m where
  shareUrl :: String -> m Unit

class (Monad m) <= UserSession m where
  currentUser :: m (Maybe User)

class (Monad m) <= SharePost m where
  sharePost :: String -> PostComment -> m Unit

class (Monad m) <= Favourite m where
  favourite :: String -> m Unit
  unfavourite :: String -> m Unit

class (Monad m) <= RenderExternalUserComponents m where
  renderUserProfile :: HTMLElement -> m Unit
  openUserProfile :: m Unit

